import { Form, Image, UploadFile } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import KnowledgeUploader from "../components/media/KnowledgeUploader";
import { useOSSFileUrl } from "../components/media/useOSSFileUrl";

interface HealthConsultationImageUploaderProps {
    form: any;
    name: string;
    label: string;
}

export default function HealthConsultationImageUploader({
    form,
    name,
    label,
}: HealthConsultationImageUploaderProps) {
    const { init, getVisitUrl } = useOSSFileUrl();
    const initRef = useRef(init);
    const getVisitUrlRef = useRef(getVisitUrl);
    const fieldValue = Form.useWatch(name, form);
    const [ossData, setOssData] = useState<any>(null);
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");

    useEffect(() => {
        initRef.current = init;
        getVisitUrlRef.current = getVisitUrl;
    }, [init, getVisitUrl]);

    useEffect(() => {
        const loadOssData = async () => {
            setOssData(await initRef.current("picture"));
        };
        loadOssData();
    }, []);

    useEffect(() => {
        let active = true;
        const syncFileList = async () => {
            if (!fieldValue) {
                setFileList([]);
                return;
            }
            const visitUrl = await getVisitUrlRef.current(fieldValue);
            if (active) {
                setFileList([{
                    uid: `saved-${name}`,
                    name: label,
                    status: "done",
                    url: visitUrl || fieldValue,
                }]);
            }
        };
        syncFileList();
        return () => {
            active = false;
        };
    }, [fieldValue, label, name]);

    const handleChange = (nextFileList: UploadFile[]) => {
        setFileList(nextFileList);
        const file = nextFileList[nextFileList.length - 1];
        if (!file) {
            form.setFieldValue(name, undefined);
            return;
        }
        if (file.status === "done" && file.url) {
            form.setFieldValue(name, file.url);
        }
    };

    return (
        <>
            <Form.Item label={label}>
                <KnowledgeUploader
                    type="picture"
                    maxCount={1}
                    value={fileList}
                    ossData={ossData}
                    listType="picture-card"
                    accept="image/*"
                    onPreview={(file: UploadFile) => {
                        setPreviewImage(file.url || "");
                        setPreviewOpen(true);
                    }}
                    onChange={handleChange}
                >
                    {fileList.length === 0 && (
                        <div>
                            <PlusOutlined />
                            <div style={{ marginTop: 8 }}>上传图片</div>
                        </div>
                    )}
                </KnowledgeUploader>
            </Form.Item>
            {previewImage && (
                <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: setPreviewOpen,
                        afterOpenChange: (visible) => !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                />
            )}
        </>
    );
}
